var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLineUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.854 6.646a.5.5 0 01-.708.708L6.5 3.707V12a.5.5 0 01-1 0V3.707L1.854 7.354a.5.5 0 11-.708-.708l4.5-4.5a.5.5 0 01.708 0l4.5 4.5zM11.5 0H.5a.5.5 0 000 1h11a.5.5 0 000-1z"
  })));
}
export default SvgArrowLineUp;